import {useEffect, useReducer} from "react";
import {statusReducer} from "../utility/statusReducer";
import API from "../logic/API";
import useAppActions from "./useAppActions";
import {AppStatusResponse} from "../logic/APITypes";
import _ from "lodash";

/** A hook for handling an initial status poll when entering a new page */
function useInitialAppStatus({
  groupId,
  apps,
}: {
  groupId: string;
  apps: {appId: string; isInstalled: boolean}[];
}) {
  const [loadingStates, dispatch] = useReducer(statusReducer, {});
  const {pollForStatus} = useAppActions(groupId);

  useEffect(() => {
    apps.forEach(({appId, isInstalled}) => {
      API.getAppStatus(groupId, appId, isInstalled).then(async (res) => {
        if (res.success && res.payload) {
          const installed: AppStatusResponse = {
            installation_status: "deployed",
            available: "available",
          };
          const uninstalled: AppStatusResponse = {
            installation_status: "not-found",
            available: "unavailable",
          };
          if (!_.isEqual(res.payload, isInstalled ? installed : uninstalled)) {
            dispatch({type: "START_LOADING", appId});
            await pollForStatus(
              appId,
              !isInstalled ? "available" : "unavailable",
            );
            dispatch({type: "STOP_LOADING", appId});
          } else {
            dispatch({type: "STOP_LOADING", appId});
          }
        }
      });
    });
  }, [apps.length]);

  return {
    loadingStates,
  };
}

export default useInitialAppStatus;
